export default __webpack_public_path__ + "static/book_seat_img-37623222a05d02c57eae02cfb4d1cb90.jpg";